import { gql } from '@apollo/client';

export const MUTATION_CREATE_MESSAGE = gql`
    mutation createMessage($data: MessageInput!) {
        createMessage(data: $data) {
            data {
                id
            }
        }
    }
`;

export const MUTATION_DELETE_MESSAGE = gql`
    mutation deleteMessage($id: ID!) {
        deleteMessage(id: $id) {
            data {
                id
            }
        }
    }
`;